import { authSession } from "./authSession";

// Cliente web do modo cookie. A virada para a base é este único valor em
// true: todo login passa a mandar o header, e a API decide por
// AUTH_COOKIE_USER_IDS. Até lá só entra quem abre /auth?transport=cookie.
export const webClientRollout = { always: false };

export const WEB_CLIENT_HEADER = "X-Fidexa-Client";
export const WEB_CLIENT_VALUE = "web";

const OPT_IN_KEY = "fidexa_cookie_opt_in";

export const rememberCookieOptIn = (params: URLSearchParams) => {
  if (params.get("transport") === "cookie") {
    sessionStorage.setItem(OPT_IN_KEY, "1");
  }
};

const optedIn = (): boolean => {
  try {
    return sessionStorage.getItem(OPT_IN_KEY) === "1";
  } catch {
    return false;
  }
};

/** Header e credenciais vão só em quem já tem bloco session ou entrou no teste. */
export const usesWebClient = (): boolean =>
  webClientRollout.always ||
  optedIn() ||
  authSession.getActiveSession() !== null;

/**
 * Na virada, quem segue com token no storage sem bloco da API reloga. Nada é
 * revogado no servidor. Depois da saída rápida para bearer a sessão tem bloco
 * e continua.
 */
export const discardLegacySession = (): boolean => {
  if (
    !webClientRollout.always ||
    !localStorage.getItem("access_token") ||
    authSession.getActiveSession()
  ) {
    return false;
  }

  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  return true;
};
